import { render } from "./WebinarVideoCard.vue?vue&type=template&id=4477c258"
import script from "./WebinarVideoCard.vue?vue&type=script&lang=js"
export * from "./WebinarVideoCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/akrug/Sites/RetirePath/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__